import React from 'react';
import { formatTimestamp } from '../../utils/formatTimestamp';
import styles from './SongPage.module.scss';

const SongInfo = ({ songDetails, userDetails, handleUserPageNavFromSong, songInfoRef }) => (
  <div ref={songInfoRef} className={styles.pageHeader}>
    <div className={styles.songInfo}>
      <h3 className={styles.title}>{songDetails.songName}</h3>
      <span className={styles.artist}>by {songDetails.songArtist}</span>
    </div>
    <div className={styles.postDetails}>
      <div
        onClick={() => handleUserPageNavFromSong(songDetails.userId)}
        className={styles.userLink}
      >
        <img
          src={userDetails?.avatar}
          alt={userDetails?.displayName}
          className={styles.avatar}
        />
        <div className={styles.postedByStack}>
          <div className={styles.postedByTop}>
            <span className={styles.postedBy}>{userDetails?.displayName}</span>
            {userDetails?.handle && (
              <span className={styles.postedByHandle}>@{userDetails.handle}</span>
            )}
          </div>
          <span className={styles.postedAt}>
            {formatTimestamp(songDetails.timestamp)}
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default SongInfo; 